import { render, staticRenderFns } from "./Login.vue?vue&type=template&id=8067d1fa&scoped=true&"
import script from "./Login.vue?vue&type=script&async=true&lang=js&"
export * from "./Login.vue?vue&type=script&async=true&lang=js&"
import style0 from "./Login.vue?vue&type=style&index=0&id=8067d1fa&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8067d1fa",
  null
  
)

export default component.exports